export const CREATE_CSV_USERS = '@ds-resource/create-csv-users'

export function createCsvUsers(data) {
  return {
    type: CREATE_CSV_USERS,
    data,
  }
}
